<script>
import ResizeObserver from 'resize-observer-polyfill'
import { VBtn, VBtnToggle } from 'vuetify/lib'
import sizeable from 'vuetify/lib/mixins/sizeable'

export default {
  name: 'SegmentedControl',
  components: { VBtn, VBtnToggle },
  mixins: [sizeable],
  props: {
    items: {
      type: [Array, Object],
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    segments: []
  }),
  computed: {
    active () {
      if (!this.segments.length) return
      return this.segments[Object.keys(this.items).indexOf(this.value)]
    }
  },
  mounted () {
    this.$calc = new ResizeObserver(this.onResize)
    this.$calc.observe(this.$el)
  },
  beforeDestroy () {
    this.$calc.unobserve(this.$el)
  },
  methods: {
    onChange (value) {
      this.$emit('input', value)
    },
    onResize ([{ target }]) {
      this.segments = Array.from(target.querySelectorAll('button')).map(el => ({
        transform: `translate(${el.offsetLeft}px, 0)`,
        width: el.offsetWidth + 'px',
        height: el.offsetHeight + 'px'
      }))
    }
  }
}
</script>

<template>
  <VBtnToggle
    :value="value"
    class="v-btn-toggle--segmented"
    borderless
    mandatory
    @change="onChange"
  >
    <div
      v-if="active"
      class="v-btn-toggle__overlay"
      :style="active"
    />

    <VBtn
      v-for="(label, key) in items"
      :key="key"
      :ripple="false"
      :value="key"
      :large="large"
      :small="small"
      :x-large="xLarge"
      :x-small="xSmall"
    >
      {{ label }}
    </VBtn>
  </VBtnToggle>
</template>

<style lang="scss">
  .v-btn-toggle--segmented {
    background-color: #F1F3F4 !important;
    border: 3px solid #F1F3F4;
    border-radius: 4px;

    button {
      background-color: transparent !important;

      &::before {
        display: none;
      }

      .v-btn__content {
        text-transform: none;
      }
    }

    .v-btn-toggle__overlay {
      background: #FFF;
      border-radius: 2px;
      position: absolute;
      transition: 0.3s ease-in-out;

      @include elevation(2);
    }
  }
</style>
